export const getRouteOrRouteFieldColor = ({
  checkedRouteIds,
  gpsVehicleColor,
  routeIds,
}: {
  checkedRouteIds?: number[];
  gpsVehicleColor: string;
  routeIds: number[];
}) => {
  const isChecked = checkedRouteIds?.find(checkedRouteId =>
    routeIds.includes(checkedRouteId),
  );

  const color = isChecked ? '#1890FF' : gpsVehicleColor;
  return color;
};
